<template>
  <div id="app">
    <loading/>
    <snackbar ef-position="bottom center" ref="snackbar" ef-duration="5000" @close="onCloseSnackbar">
      <span v-html="application.snackbar.message"></span>
      <button v-if="application.snackbar.action.text && application.snackbar.action.handler" @click="application.snackbar.action.handler">{{ application.snackbar.action.text }}</button>
    </snackbar>
    <router-view></router-view>
  </div>
</template>

<script>
  import { mapState, mapActions } from 'vuex';
  import snackbar from '@/components/snackbar/Snackbar';
  import loading from '@/components/loading/Loading';
  import interceptors from '@/interceptors';

  export default {
    name: 'edoc-factory-responsive',

    components: {
      snackbar,
      loading,
    },
    mixins: [interceptors],
    computed: {
      ...mapState('application', {
        application: state => state,
        active: state => state.snackbar.active,
      }),
    },
    methods: {
      ...mapActions({
        getAppInfos: 'auth/loadInfos',
        setAuthorization: 'auth/setAuthorization',
      }),
      onCloseSnackbar() {
        this.$store.dispatch('application/closeSnackbar');
      },
    },
    watch: {
      active(active) {
        if (active === true) {
          this.$refs.snackbar.open();
        }
      },
    },
    created() {
      this.setInterceptors();
      this.getAppInfos();
    },
    mounted() {
      this.setAuthorization();
    },
  };
</script>



// WEBPACK FOOTER //
// App.vue?a554dd3c